export function toggleDrop() {
    const buttonDropdown = document.querySelectorAll("[data-action='open-accordion']")

    buttonDropdown.forEach((item, index) => {
        buttonDropdown[index].addEventListener("click", (e) => {
            console.log(e.srcElement.nextSibling.nextElementSibling)
            e.srcElement.nextSibling.nextElementSibling.classList.toggle("open")
            e.srcElement.classList.toggle("active")
        })
    })
}
export function setParamsUrl() {
    const urlParams = new URLSearchParams(window.location.search);

    const options = []
    urlParams.get("sindicato") ? options.push(urlParams.get("sindicato").replace(/\s/g, '-')) : '';
    urlParams.get("cidade") ? options.push(urlParams.get("cidade").replace(/\s/g, '-')) : '';
    urlParams.get("regiao") ? options.push(urlParams.get("regiao").replace(/\s/g, '-')) : '';
    document.querySelectorAll("select").forEach((select) => {
        options.forEach((item) => {
            if (item) {
                if (select.nextSibling.querySelector(`li[data-value="${item !== '' ? item : ''}"]`)) {
                    select.nextSibling.querySelector(`li[data-value="${item !== '' ? item : ''}"]`).click()
                    select.nextSibling.classList.remove("open")
                }
            }
        })
    })
}

toggleDrop()
setParamsUrl()
